import React from 'react'
import MainLayout from '@layouts/main-layout'
import Head from '@modules/common/components/head'
import Warranty from '@components/warranty'

const WarrantyPage = () => {
  return (
    <>
      <Warranty />
    </>
  )
}

WarrantyPage.getLayout = (page: React.ReactElement) => {
  return (
    <MainLayout>
      <Head />
      {page}
    </MainLayout>
  )
}

export default WarrantyPage
